import { render, staticRenderFns } from "./Product-Tab-Detail-Field.vue?vue&type=template&id=89bdcd7e"
import script from "./Product-Tab-Detail-Field.vue?vue&type=script&lang=js"
export * from "./Product-Tab-Detail-Field.vue?vue&type=script&lang=js"
import style0 from "./Product-Tab-Detail-Field.vue?vue&type=style&index=0&id=89bdcd7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports